import { Chip, Typography, useTheme, Box } from '@mui/material';
import { IconButton, TableCell, styled } from '@mui/material';
import {
  internetCategory,
  resourceCategory,
} from '~/api/oneBoxV3/oneBoxV3.type';

import { pxToRem } from '~/theme/typography';

type TTypeChip = {
  type: resourceCategory | internetCategory;
};

export const SORT_ICON_STYLE = (isSelected: boolean) => {
  const theme = useTheme();
  return {
    fontSize: pxToRem(14),
    fill: isSelected ? theme.palette.grey[700] : theme.palette.grey[500],
  };
};

export const cell = {
  Container: styled(TableCell)(({ theme }) => ({
    padding: '9px 6px',
    color: theme.palette.grey[800],
    fontWeight: '500',
    fontSize: pxToRem(14),
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  })),
  EditIconButton: styled(IconButton)(({ theme }) => ({
    borderRadius: '8px',
    width: '36px',
    height: '36px',
    padding: '0px',
    backgroundColor: theme.palette.info.lighter,
    '&:hover': { backgroundColor: theme.palette.info.light },
  })),
  EllipsisText: styled(Typography)(() => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': '2',
  })),
  TypeChip: styled(Chip)<TTypeChip>(({ type, theme }) => {
    let backgroundColor = '';
    let color = '';
    switch (type) {
      case resourceCategory.SCHOOL:
        backgroundColor = theme.palette.info.lighter;
        color = theme.palette.info.dark;
        break;
      case resourceCategory.CRAM_SCHOOL:
        backgroundColor = theme.palette.success.lighter;
        color = theme.palette.success.dark;
        break;
      default:
        backgroundColor = theme.palette.background.neutral;
        color = theme.palette.grey[600];
    }
    return {
      fontSize: pxToRem(12),
      fontWeight: '700',
      backgroundColor,
      color,
    };
  }),
  HeaderContent: styled(Typography)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: pxToRem(14),
    fontWeight: '500',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  })),
};

export const loading = {
  stackContainer: styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
    padding: '36px',
  })),
};
